const state = {
    msgList: [],
    sysMsgList: [],
}
const mutations = {
    MSG_ADD_NEW_CHAT_MSG(state, msg) {
        //state.giftList = data;
        msg.msgType = 1;
        state.msgList.push(msg);
    },
    MSG_ADD_NEW_SYS_MSG(state, msg) {
        //state.giftList = data;
        msg.msgType = 0;
        state.sysMsgList.push(msg);
    },
    MSG_ADD_NEW_ENTER_MSG(state, msg) {
        //state.giftList = data;
        msg.msgType = 2;
        state.sysMsgList.push(msg);
    },
    MSG_ADD_NEW_WINNING_MSG(state, msg) {
        //state.giftList = data;
        msg.msgType = 3;
        state.msgList.push(msg);
    },
    MSG_CLEAR_MSG(state, msg) {
        state.msgList = [];
        state.sysMsgList = [];
    }

}

// this message is similar to post message. It's async
const actions = {
    msg_add_new_chat_msg({
        commit
    }, msg) {
        commit('MSG_ADD_NEW_CHAT_MSG', msg)
    },
    msg_add_new_sys_msg({
        commit
    }, msg) {
        commit('MSG_ADD_NEW_SYS_MSG', msg)
    },
    msg_clear_msg({
        commit
    }, msg) {
        commit('MSG_CLEAR_MSG', msg)
    }
}
export default {
    state,
    mutations,
    actions
}